import { axiosBase } from '@/plugins/axios'

export class ProgramGroups {
  getGroups() {
    return axiosBase.get('/v2/projects/template-group').then((response) => response.data)
  }
}
